module.exports = __webpack_public_path__ + "img/antes_despues_51.8f158fb5.png";